// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface TableServicesListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface TableServicesSetServicePropertiesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface TableServicesGetServicePropertiesOptionalParams extends OperationOptions {}
